import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Dashboard } from "components";

import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;

const BasicData = ({
  producer_id,
  refetch,
  handleSubmit,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/producers/${producer_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(Object.fromEntries(err));
    },
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Podstawowe informacje", icon: "info" }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Field name="name" label="Nazwa" component={InputField} type="text" />
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Nazwa produktu jest wymagana!";
  }

  return errors;
};

export default reduxForm({
  form: "update-producer",
  enableReinitialize: true,
  validate,
})(BasicData);
